var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoffee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4575 11.1797H19.8473C21.6988 11.1797 22.2491 11.4452 22.2045 12.7635C22.1307 14.9471 21.146 17.4844 17.207 18.1797",
    stroke: "#B7903B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1533 21.2942C2.77888 18.6997 2.28171 15.0198 2.20846 11.1798C2.17682 9.52099 2.65829 9.17969 4.86622 9.17969H15.5478C17.7557 9.17969 18.2372 9.52099 18.2056 11.1798C18.1323 15.0198 17.6351 18.6997 14.2607 21.2942C13.3004 22.0325 12.4901 22.1797 11.1264 22.1797H9.28767C7.92389 22.1797 7.11361 22.0325 6.1533 21.2942Z",
    stroke: "#B7903B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5159 3.17969C10.9692 3.5183 10.2082 4.67969 10.2082 6.17969M7.74674 4.67969C7.74674 4.67969 7.20703 5.17969 7.20703 6.17969M14.2082 4.67969C13.9349 4.84899 13.707 5.67969 13.707 6.17969",
    stroke: "#B7903B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/coffee.50a1a13fa3f03b889546a6753d1fe59b.svg";
export { ForwardRef as ReactComponent };